export const PermissionsSystem = '4f09f0c8-d166-4492-b881-4c627f603606';
export const PermissionGroupsManagement =
  '898ce11c-e684-4585-b8b8-16437f4e76e8';
export const UsersManagement = '5330f5d9-35cb-44c4-a83e-7aa66218b7f2';
export const CustomersManagement = '1e7dd6d0-3b1e-46ce-bd04-952a1d4107ee';
export const FilesSystem = 'fd4c782e-af30-45d0-ab60-f7ac4d329228';
export const SecuritySettingsIdentifier = '62de10a4-08b3-4a7e-8209-b044808df635';
export const SystemCustomerID = 'a7c44fcf-c755-44e9-8aa6-2559611e75ff';
export const EmptyGuid = '00000000-0000-0000-0000-000000000000';
